/* eslint semi:0 */
import BaseVm from '../vms/BaseVm'
import lazyLoadStore from '../stores/lazyLoadStore'
import lazyLoadActions from '../actions/lazyLoadActions'
import scrollingEventsProvider from '../../providers/scrollingEventsProvider'

export default class LazyLoadService extends BaseVm {
  constructor(options = {}) {
    options.store = options.store || lazyLoadStore
    super(options)
    this.loadCallback = options.loadCallback
    this.loadTriggerElement = options.loadTriggerElement
    this.loadCallbackExecuted = false
    this.registerScrollingActions()
  }

  onChange(action) {
    if (!this.loadCallbackExecuted && this.loadCallback) {
      this.loadCallback()
      this.loadCallbackExecuted = true
    }
  }

  loadTargetReached(scrollingEventObject) {
    if (scrollingEventObject.isInitial && !scrollingEventObject.isInViewport) {
      return
    }
    lazyLoadActions.loadTargetReached({
      scrollingEventObject,
      element: this.loadTriggerElement,
    })
  }

  registerScrollingActions() {
    let vm = this
    this.scrollingEvents.forEach(function(eventConfig) {
      eventConfig.vm = vm
      setImmediate(() => {
        vm.loadTargetReached({
          isInViewport: scrollingEventsProvider.checkIfElementInViewport(eventConfig),
          isInitial: true,
        })
      })
      scrollingEventsProvider.register(eventConfig)
    })
    return this
  }

  get scrollingEvents() {
    let { loadTriggerElement } = this
    return [
      {
        element: loadTriggerElement,
        triggerPosition: {
          bottom: 100, //height percentage from top
          //bottom: 100 height percentage from bottom
        },
        event: 'loadTargetReached',
        relativeTopElement: loadTriggerElement,
      },
    ]
  }

  static loadMedia(el) {
    if (!el) {
      return
    }
    for (let media of el.querySelectorAll('img')) {
      media.setAttribute('src', media.dataset.src)
      delete media.dataset.src
    }
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/LazyLoadService.js